import { vdkEmHappinessPortalApi } from './vdk-em-happiness-portal-api';
const getAllEmailPreferences = () => {
    return vdkEmHappinessPortalApi.get('/emailpreferences');
};
const getEmailPreferenceById = (id) => {
    return vdkEmHappinessPortalApi.get(`/emailpreferences/${id}`);
};
const createEmailPreference = (payload) => {
    return vdkEmHappinessPortalApi.post('/emailpreferences/create', payload);
};
const updateEmailPreference = (id, payload) => {
    return vdkEmHappinessPortalApi.put(`/emailpreferences/${id}`, payload);
};
const EmailPreferencesApi = {
    getAllEmailPreferences,
    getEmailPreferenceById,
    createEmailPreference,
    updateEmailPreference
};
export default EmailPreferencesApi;
